module.exports = __webpack_public_path__ + "img/circle2yellow.752e214e.png";